export class ReutilizacionMasivaRequest {
   ids: string[];
   usuarioId: string;
}
